<!--
__________________________________________________
Summary 
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Vue component for changing entity optin settings.

General usage of this component will not need to specify inline properties on the component. 
All use cases will involve directly invoking showOptions 

__________________________________________________
Methods
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾

showOptions()
Opens the switch accounts dialog 
__________________________________________________
Usage
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Register the entityOptin component in the template entry-point of your application, including 'ref="entityOptions"': 
<entityOptions ref="entityOptions" />

From javascript within any Vue components, you can reference the showOptions method via the $root.$refs.entityOptions handle. 
Example:

  // show a message dialog
  $root.$refs.entityOptions.showOptions();

-->

<template>
  <div id="divEntityOptions" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myModalLabel">{{displayTitle}}</h4>
          <button type="button" class="close" data-dismiss="modal" v-on:click="processClose()"aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <table class="table table-sm">
              <tbody>
                <tr v-for="option in options">
                  <td class="align-middle pr-3"><span class="font-weight-semibold" :class="{'text-muted': !option.optedIn}">{{option.name}}</span> <span v-if="option.optedIn" class="glyphicons glyphicons-ok-circle text-success"></span></td>
                  <td align="right">
                    <button v-if="option.optedIn && !disableOptout" class="btn btn-xs btn-dropdown-default" @click="setOptinState($event,option,false)">Opt Out</button> 
                    <button v-else-if="!option.optedIn && !disableOptin" class="btn btn-xs btn-dropdown-default" @click="setOptinState($event,option,true)">Opt In</button>
                    <div v-else class="text-muted small">{{option.optedIn ? "Opt-out" : "Opt-in"}} is not enabled for this sub-account.</div> 
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
        <div class="modal-footer">

          <button type="button" class="btn btn-primary"
            data-dismiss="modal">Close</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
    }),
    accounts: function(){
      return this.uiConfig.accounts;
    },
    activeAccount: function() {
      if (this.uiConfig.account && this.uiConfig.account.id!=null) {
        return this.uiConfig.account;
      } else {
        return {};
      }
    },
    displayTitle: function() {
      if (this.title) {
        return this.title;
      } else {
        return "Set Optin Settings"
      }
    }
  },
  data: function () {
    return {
      title: "Set Optin Settings",
      options: [],
      contact_id: null,
      entity: null,
      subAccount: null
    }
  },
  methods: {
    showOptions: function(params) {
      this.title = params.title;
      this.options = params.options;
      this.entity = params.entity;
      this.contact_id = params.contact_id;
      this.subAccount = params.subAccount;
      this.disableOptin = this.subAccount.disable_optin;
      this.disableOptout = this.subAccount.disable_optout;
      $('#divEntityOptions').modal('show');
      $('#divEntityOptions button').removeClass('blinky-blink');
      this.$forceUpdate();
    },
    setOptinState(evt, option, changeState) {

      $(evt.target).addClass('blinky-blink');
      this.$parent.updateEntityOptin(this.subAccount,this.entity,this.contact_id,option);
      
    },
    processClose() {

    }
  },
}
</script>

<style scoped>
  table td, table th {
    border: none;
  }

  .blinky-blink {
    -webkit-animation-name: blinker;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: cubic-bezier(.5, 0, 1, 1);
    -webkit-animation-duration: 1.1s;
  }
  @-webkit-keyframes blinker {
    from { opacity: 1.0; }
    to { opacity: 0.0; }
  }

</style>